import { Image } from "@/components/common/Image"
import { useMediaQuery } from "@/hooks/useMediaQuery"
import { selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import clsx from "clsx"
import { CreditCard, Landmark, LayoutDashboard, NotepadText, Settings, ShieldCheck } from "lucide-react"
import { FormattedMessage } from "react-intl"
import { NavLink, useLocation } from "react-router-dom"
import "./style.sass"
type Props = {
  isOpen: boolean
  toggleNav: () => void
  onClose: () => void
}

export const SidebarNav = ({ isOpen, onClose, toggleNav }: Props) => {
  const isMobile = useMediaQuery("(max-width: 991px)")
  const { card_active, iban_active } = useStoreClient(selectUser)
  const pathname = useLocation().pathname
  let logoUrl = "logo-vert.svg"
  if (isMobile) {
    logoUrl = "logo-dark.svg"
  }
  return (
    <div className="header-sidebar py-3 md:py-2">
      <div className={`btn-header-sidebar ${isOpen ? "is-active" : ""}`} onClick={toggleNav} />

      <a href={process.env.REACT_APP_PATH_HOME} className="header-sidebar_logo" target="_blank" rel="noreferrer">
        <Image src={logoUrl} alt={process.env.REACT_APP_COMPANY_NAME} />
      </a>
      <ul className={`list-none header-sidebar_nav ${isOpen ? "active" : ""}`} onClick={() => setTimeout(onClose, 1)}>
        <li className="header-sidebar_li">
          <NavLink to="/" exact>
            <LayoutDashboard size={22} />
            <span>
              <FormattedMessage id="dashboard" />
            </span>
          </NavLink>
        </li>
        <li className="header-sidebar_li">
          <NavLink to="/transactions">
            <NotepadText size={22} />
            <span>
              <FormattedMessage id="orders" />
            </span>
          </NavLink>
        </li>
        <li className="header-sidebar_li">
          <NavLink to="/verifications/exchange" className={clsx(pathname.includes("/verifications") && "active")}>
            <ShieldCheck size={22} />
            <span>
              <FormattedMessage id="verification" />
            </span>
          </NavLink>
        </li>
        {card_active && (
          <li className="header-sidebar_li">
            <NavLink to="/cards">
              <CreditCard size={22} />
              <span>
                <FormattedMessage id="cards" />
              </span>
            </NavLink>
          </li>
        )}
        {iban_active && (
          <li className="header-sidebar_li">
            <NavLink to="/iban/payments">
              <Landmark size={22} />
              <span>
                <FormattedMessage id="bank-payments" />
              </span>
            </NavLink>
          </li>
        )}
        {iban_active && (
          <li className="header-sidebar_li">
            <NavLink to="/iban/requisites">
              <Landmark size={22} />
              <span>
                <FormattedMessage id="bank-requisites" />
              </span>
            </NavLink>
          </li>
        )}
        <li className="header-sidebar_li">
          <NavLink to="/settings">
            <Settings size={22} />
            <span>
              <FormattedMessage id="settings" />
            </span>
          </NavLink>
        </li>
      </ul>
    </div>
  )
}
